import React, { useEffect, useRef } from 'react';
import { Box } from '@withjoy/joykit';
import { EventLogisticsBlock } from '../../../../components/EventLogisticsBlock';
import { alohaConfig, CONTAINER_BLOCK_PADDING_X, CONTENT_BLOCK_MAX_WIDTH } from '../../LayoutAloha.theme';
import { useAlohaScrollWatch } from '../../hooks/useAlohaScrollWatch';
import { CtaButtons } from '@apps/guest/packages/layout-engine/components/CtaButtons/CtaButtons';
import { GuestSiteTypographyOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride';
import { button2ToButtonsOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride.constants';
import { animationTransition } from '@shared/utils/animationTransition';
import type { WelcomeCardProps } from './WelcomeCard.types';
import { CustomArt } from '../CustomArt/CustomArt';

const { simple } = alohaConfig.applicatorHtmlProps;

export const WelcomeCard: React.FC<WelcomeCardProps> = ({
  homeRef,
  page,
  eventHandle,
  location,
  finalizedDate,
  hideEventCountdown,
  nextPageSlug,
  isCustomArtEnabled,
  customArtUrl,
  pages,
  onRSVPButtonClicked,
  onViewDetailsButtonClicked,
  onNotYouButtonClicked,
  onNotYouErrorRequest,
  ...restProps
}) => {
  const { currentPage } = useAlohaScrollWatch(homeRef, page);
  const firstTimeOnWelcomePage = useRef(true);

  useEffect(() => {
    if (currentPage !== 'welcome' && firstTimeOnWelcomePage.current) {
      firstTimeOnWelcomePage.current = false;
    }
  }, [currentPage]);

  return (
    <Box
      key={page.pageSlug}
      data-testid={'page-welcome'}
      height={'100vh'}
      display={'flex'}
      alignItems="center"
      justifyContent={'center'}
      position={'relative'}
      flexDirection={'column'}
      paddingX={CONTAINER_BLOCK_PADDING_X}
      overflowY={'hidden'}
      transition={animationTransition('background-color', 'color')}
      style={{
        color: 'inherit',
      }}
      {...(isCustomArtEnabled ? {} : simple.prop)}
      {...restProps}
    >
      <Box
        maxWidth={CONTENT_BLOCK_MAX_WIDTH}
        marginX="auto"
        width="100%"
      >
        {isCustomArtEnabled && <CustomArt backgroundImageUrl={customArtUrl} />}
        <EventLogisticsBlock
          showViewDetailsButton={firstTimeOnWelcomePage.current}
          eventHandle={eventHandle}
          page={page}
          location={location}
          date={finalizedDate}
          hideEventCountdown={hideEventCountdown}
          shouldBreakDate
          pages={pages}
          onViewDetailsButtonClicked={onViewDetailsButtonClicked}
        >
          <GuestSiteTypographyOverride override={button2ToButtonsOverride}>
            <CtaButtons
              onRSVPButtonClicked={onRSVPButtonClicked}
              onNotYouButtonClicked={onNotYouButtonClicked}
              onNotYouErrorRequest={onNotYouErrorRequest}
            />
          </GuestSiteTypographyOverride>
        </EventLogisticsBlock>
      </Box>
    </Box>
  );
};
